/*
 * Copyright 2020 Google Inc. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class Shell {
    constructor(stream, callbackFunction) {
        this.stream = stream;
        this.callbackFunction = callbackFunction;
        this.textDecoder = new TextDecoder();
        this.textEncoder = new TextEncoder();
        this.messageListener = [];
        this.closed = false;
        this.loopRead();
    }
    loopRead() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let message;
                do {
                    message = yield this.stream.read();
                    if (message.header.cmd === 'WRTE') {
                        this.stream.write('OKAY');
                        const data = this.textDecoder.decode(message.data);
                        if (this.callbackFunction) {
                            this.callbackFunction(data);
                        }
                    }
                    // Resolve Messages waiting for this event
                    for (const listener of this.messageListener) {
                        listener(message);
                    }
                } while (!this.closed);
            }
            catch (e) {
                console.error('loopRead crashed', e);
            }
            this.stream.client.unregisterStream(this.stream);
        });
    }
    waitForMessage(cmd) {
        return new Promise(resolve => {
            const callback = (message) => {
                if (message.header.cmd === cmd) {
                    const pos = this.messageListener.indexOf(callback);
                    this.messageListener.splice(pos, 1);
                    resolve(message);
                }
            };
            this.messageListener.push(callback);
        });
    }
    write(command) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = this.textEncoder.encode(command);
            yield this.stream.write('WRTE', new DataView(data.buffer));
            yield this.waitForMessage('OKAY');
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            this.closed = true;
            yield this.write('CLSE');
        });
    }
}
//# sourceMappingURL=Shell.js.map